<template>
  <div class="direct-bind-wrapper">
    <div class="bind-type-wrapper">
      <!--<article class="weui-article">-->
      <!--&lt;!&ndash;<section>&ndash;&gt;-->
      <!--<p>请输入该停车券要绑定的车牌，车辆出入时，系统会自动找到该停车券。</p>-->
      <!--&lt;!&ndash;</section>&ndash;&gt;-->
      <!--</article>-->
      <article class="weui-article">
        <!--<section>-->
        <p style="font-size: 16px; font-weight: 500">
          停车时长: {{ parkHours || "暂无" }}
        </p>
        <p style="font-size: 16px; font-weight: 500">进场时间: {{ inTime || "暂无" }}</p>
        <!--</section>-->
      </article>
      <div ref="plateForm" class="weui-form-area">
        <div class="weui-cells weui-cells_form">
          <plate-input ref="plateInput1"></plate-input>
        </div>
        <div class="weui-btn-area">
          <button :disabled="isClicked" class="weui-btn" :class="isClicked ? 'weui-btn_disabled' : 'weui-btn_primary'"
            @click="handleConfirm">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkNumberIsIn } from "../../../api/coupon/userNoFollowToGetCoupon";
import { validatePlate } from '@/utils/plateValidator'
import { userGetCoupon } from "../../../api/coupon/userGetCoupon";
import plateInput from "../components/plateInput";
import { pay } from "../../../api/coupon/pay";
import { mapGetters } from "vuex";
export default {
  name: "index",
  data() {
    return {
      isClicked: false,
      inTime: undefined,
      parkHours: undefined,
      id: undefined,
      couponId: undefined,
      platenumber: undefined,
      parkinglotId: undefined,
    };
  },
  components: {
    plateInput,
  },
  computed: {
    ...mapGetters(["userOpenid"]),
  },
  created() {
    // this.id = this.taskId;
    console.log(this.GetQueryString("bindMethod"), "bindMethod");
    if (this.GetQueryString("isUserBindPlate")) {
      this.id = this.$encryptUtil.decrypt(this.GetQueryString("taskId"));
      console.log(this.id, "this.id");
      this.parkinglotId = this.$encryptUtil.decrypt(this.GetQueryString("parkinglotId"));
    }
    if (this.GetQueryString("bindMethod") == 1) {
      this.couponId = this.$encryptUtil.decrypt(this.GetQueryString("couponId"));
      this.parkinglotId = this.$encryptUtil.decrypt(this.GetQueryString("parkinglotId"));
    }
  },
  methods: {
    getPlateNumber(data) {
      console.log("传值", data);
      this.platenumber = data;
    },
    /*获取地址栏参数**/
    GetQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /*验证输入框非空**/
    handleConfirm() {
      // if (!this.$refs.plateInput1.getPlateNumber()) {
      //   this.$weui.alert('请输入正确的车牌号')
      //   return
      // }

      if (validatePlate(this.$refs.plateInput1.getPlateNumber()).valid) {
        this.isClicked = true;
        if (this.GetQueryString("bindMethod") == 1) {
          checkNumberIsIn({parkinglotId: this.parkinglotId,platenumber: this.$refs.plateInput1.getPlateNumber(),}).then((res) => {
              if (res.code === 200) {
                let params = {
                  bindMethod: 1,
                  couponId: this.couponId,
                  needuserBindplatenumber: "0",
                  scanType: 2,
                  platenumber: this.$refs.plateInput1.getPlateNumber(),
                };
                userGetCoupon(params)
                  .then((res) => {
                    if (res.code === 200) {
                      this.isClicked = true;
                      this.$weui.alert("领券成功", { title: "提示" });
                    } else {
                      throw new Error();
                    }
                  })
                  .catch(() => {
                    this.isClicked = false;
                  });
              } else {
                throw new Error();
              }
            })
            .catch(() => {
              this.isClicked = false;
              this.$weui.alert("错误，请重试！");
            });

        } else {
          checkNumberIsIn({parkinglotId: this.parkinglotId,platenumber: this.$refs.plateInput1.getPlateNumber(),}).then((res) => {
              if (res.code === 200) {
                this.inTime = res.data.inTime;
                this.parkHours = res.data.parkHours;
                let form = {
                  bindMethod: 8,
                  platenumber: this.$refs.plateInput1.getPlateNumber(),
                  couponTaskId: this.id,
                };
                this.userGetCoupon(form);
              } else {
                throw new Error();
              }
            })
            .catch(() => {
              this.isClicked = false;
              this.$weui.alert("错误，请重试！");
            });


        }
      
      } else {
        this.$weui.alert("车牌号长度有误！");
      }
    },
    /*用户领券**/
    userGetCoupon(form) {
      userGetCoupon(form)
        .then((res) => {
          if (res.code === 200) {
            this.isClicked = true;
            this.$weui.alert("领券成功", { title: "提示" });
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          this.isClicked = false;
        });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~common/stylus/variable';
.bind-type-wrapper{
	padding-top 20px
	.type-title{
		color #F43430
		font-size $article-p
		text-align center
		display flex
		div{
			width 10px
			height 10px
			line-height 10px
			text-align center
			font-weight 500
			padding 3px
			border-radius 50%
			border 1px solid #F43430
			margin auto
		}
	}
	.weui-article{
		padding-top 0
		padding-bottom 0
		p{
			color $article-merchant-p
			font-size $article-merchant-p
			line-height 20px
		}
	}
	.weui-cells{
		.weui-cell{
			padding 15px
		}
	}
	.weui-btn-area{
		margin-top 20px
		.weui-btn{
			width: 100%;
		}
		p{
			font-size $article-p
			color $article-merchant-p
			line-height 20px
			padding-top 10px
		}
	}
}
</style>
